const selectAuth = (state) => state.auth;

export default selectAuth;
